import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Layout } from '@taxora-shared-layout/ui';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [Layout, RouterOutlet],
  templateUrl: './main-layout.html',
  styleUrls: ['./main-layout.scss'],
})
export class MainLayout {}
